import { render, staticRenderFns } from "./OnboardingAgreement.vue?vue&type=template&id=229d0c1d&"
import script from "./OnboardingAgreement.vue?vue&type=script&lang=js&"
export * from "./OnboardingAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports